import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Project Member
export const createProjectMember = createAsyncThunk(
    'projectMembers/createProjectMember',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/projects/members', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create project member');
        }
    }
);

// Get Project Member by ID
export const fetchProjectMemberById = createAsyncThunk(
    'projectMembers/fetchProjectMemberById',
    async ({ projectMemberId }: { projectMemberId: number }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/projectMembers/${projectMemberId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch project member');
        }
    }
);

// Get All Project Members by Project ID
export const fetchAllProjectMembers = createAsyncThunk(
    'projectMembers/fetchAllProjectMembers',
    async ({ projectId }: { projectId: number }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/projects/${projectId}/members`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch project members');
        }
    }
);

// Update Project Member
export const updateProjectMember = createAsyncThunk(
    'projectMembers/updateProjectMember',
    async ({ projectMemberId, ...data }: any & { projectMemberId: number }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/projectMembers/${projectMemberId}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update project member');
        }
    }
);

// Delete Project Member (soft delete)
export const deleteProjectMember = createAsyncThunk(
    'projectMembers/deleteProjectMember',
    async ({ projectMemberId }: { projectMemberId: number }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/projectMembers/${projectMemberId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete project member');
        }
    }
);
